var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAwesomeHospital = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.289,
    height: 42.616,
    viewBox: "0 0 37.289 42.616",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hospital",
    "data-name": "Icon awesome-hospital",
    d: "M37.289,40.951v1.665H0V40.951a1,1,0,0,1,1-1H2.664V9.988a2,2,0,0,1,2-2h7.325V2a2,2,0,0,1,2-2h9.322a2,2,0,0,1,2,2V7.991h7.325a2,2,0,0,1,2,2V39.953H36.29A1,1,0,0,1,37.289,40.951ZM25.636,15.981H22.307a1,1,0,0,0-1,1v3.329a1,1,0,0,0,1,1h3.329a1,1,0,0,0,1-1V16.98A1,1,0,0,0,25.636,15.981ZM11.653,21.308h3.329a1,1,0,0,0,1-1V16.98a1,1,0,0,0-1-1H11.653a1,1,0,0,0-1,1v3.329A1,1,0,0,0,11.653,21.308Zm8.656,10.654H16.98a1,1,0,0,0-1,1v6.992h5.327V32.961A1,1,0,0,0,20.309,31.962Zm5.327-7.991H22.307a1,1,0,0,0-1,1V28.3a1,1,0,0,0,1,1h3.329a1,1,0,0,0,1-1V24.97A1,1,0,0,0,25.636,23.972Zm-9.655,1a1,1,0,0,0-1-1H11.653a1,1,0,0,0-1,1V28.3a1,1,0,0,0,1,1h3.329a1,1,0,0,0,1-1Zm-.832-16.98h2.164v2.164a.5.5,0,0,0,.5.5h1.665a.5.5,0,0,0,.5-.5V7.991H22.14a.5.5,0,0,0,.5-.5V5.826a.5.5,0,0,0-.5-.5H19.976V3.163a.5.5,0,0,0-.5-.5H17.812a.5.5,0,0,0-.5.5V5.327H15.149a.5.5,0,0,0-.5.5V7.491A.5.5,0,0,0,15.149,7.991Z",
    fill: "#0046a7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAwesomeHospital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/awesome-hospital.a7d0bbab95f4c52b16ed10f0736383d4.svg";